import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { reportingService } from '../../services/reportingService';

export const useGetTakeRateStatus = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.reporting.status],
    queryFn: () =>
      reportingService.status().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }

        return null;
      }),
  });
};
